import $ from 'jquery';
import axios from 'axios';

/**
 * Premium search plugin
 */
export default class PremiumSearch {
    /**
     * @param $premiumSearch Premium search container
     * @param options Additional options
     */
    constructor($premiumSearch, options = {}) {
        this.options = $.extend(true, {
            classes: {
                form: 'premium-search__form',
                number: 'registration_nr',
                series: 'series_nr',
                submit: 'btn-submit',
                pdf: 'premium-search__pdf',
                sum: 'premium-search__sum',
                list: 'premium-search__list',
                table: 'premium-search__table',
                errors: 'filter-block__errors'
            },
        },
            this.state = {
                isLoading: false, // true if any loading is on page
            },
            options);

        if (!$premiumSearch) {
            return;
        }

        this.$premiumSearch = $premiumSearch;
        this.$form = this.$premiumSearch.querySelector('#' + this.options.classes.form);
        this.$number = this.$premiumSearch.querySelector('#' + this.options.classes.number);
        this.$series = this.$premiumSearch.querySelector('#' + this.options.classes.series);
        this.$submit = this.$premiumSearch.querySelector('.' + this.options.classes.submit);
        this.$list = this.$premiumSearch.querySelector('.' + this.options.classes.list);
        this.$pdf = this.$premiumSearch.querySelector('.' + this.options.classes.pdf);
        this.$table = this.$premiumSearch.querySelector('.' + this.options.classes.table);
        this.$errors = this.$premiumSearch.querySelector('.' + this.options.classes.errors);
        this.$sum = this.$premiumSearch.querySelectorAll('.' + this.options.classes.sum);

        this.init();
    }

    init() {
        this.handleToggle(this.$premiumSearch);
    }

    submitForm($this) {

        this.numberFormat();
        
        if (this.$number.value !== '') {
            this.toggleLoader(true);
            this.$errors.innerText = '';

            let series = this.options.classes.series + '=' + this.$series.value;
            let number = this.options.classes.number + '=' + this.$number.value;

            let config = {
                headers: {
                    'Accept': '*/*',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            }

            axios.get('?' + series + '&' + number, config)
                .then(function (response) {
                    $this.validateForm(response.data);
                    $this.toggleLoader(false);
                })
                .catch(function (error) {
                    $this.toggleLoader(false);
                    $this.$table.classList.add('premium-search__table--hidden');
                });
        } else {
            this.$errors.innerText = 'Podanie numeru obligacji jest wymagane';
        }
    }

    validateForm(data) {
        if (data.message) {
            this.$table.classList.add('premium-search__table--hidden');
            this.$errors.innerText = data.message;
        } else {
            this.$table.classList.remove('premium-search__table--hidden');

            this.$pdf.href = data.pdf_file_path;
            this.$sum.forEach((s) => {
                s.innerText = data.sum_premium_value;
            });

            this.$list.innerText = '';
            data.results.forEach((r) => {
                let tr = document.createElement('tr');
                let td1 = document.createElement('td');
                let td2 = document.createElement('td');
                td1.innerText = r[0];
                td2.innerText = r[1];
                tr.append(td1, td2);
                this.$list.append(tr);
            });
        }
    }

    numberFormat() {
        this.$number.value = this.$number.value.replace(/[^0-9]/g, '');
    }

    toggleLoader(state) {
        this.state.isLoading = state;
        this.$premiumSearch.querySelector('.filter-block').classList.toggle('filter-block--loading', state);

        if (state) {
            this.$premiumSearch.querySelector('.filter-block').insertAdjacentHTML('beforeend', '<div class="loader"></div>')
        } else {
            this.$premiumSearch.querySelector('.filter-block').querySelector('.loader').remove();
        }
    }

    handleToggle() {

        const submitHandler = (e) => {
            e.preventDefault();
            this.submitForm(this);
        }

        const numberFormatHandler = (e) => {
            this.numberFormat();
        }

        this.$submit.addEventListener('click', submitHandler);
        this.$number.addEventListener('keyup', numberFormatHandler);
        this.$number.addEventListener('keydown', numberFormatHandler);
    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/common/premium-search.js